import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

/*
 * Badging and the assist pane.
 *
 * The one rule that must not be softened: anything not approved is labelled a
 * machine translation, every time, with no exception. The assist pane is
 * unapproved by definition, so it always carries the badge.
 */
export default class TranslationPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.requested = null;
    this.error = null;
  }

  view() {
    const { post, resolved } = this.attrs;
    const display = resolved.display || {};
    const assist = this.requested || resolved.assist;

    return (
      <div className="SfTranslate">
        {this.badge(display)}
        {assist ? this.assistPane(assist) : null}
        {!assist && display.kind === 'original' ? this.translateButton(post) : null}
        {this.error ? <div className="SfTranslate-error">{this.error}</div> : null}
      </div>
    );
  }

  badge(display) {
    if (display.kind === 'translation') {
      return (
        <span className="SfTranslate-badge SfTranslate-badge--reviewed">
          {app.translator.trans('scoreflection-translate.forum.badge.reviewed', {
            lang: (display.lang || '').toUpperCase(),
          })}
        </span>
      );
    }
    if (!display.lang) return null;

    return (
      <span className="SfTranslate-badge">
        {app.translator.trans('scoreflection-translate.forum.badge.original', {
          lang: display.lang.toUpperCase(),
        })}
      </span>
    );
  }

  assistPane(assist) {
    return (
      <div className="SfTranslate-assist">
        <div className="SfTranslate-assist-head">
          <span className="SfTranslate-badge SfTranslate-badge--machine">
            {app.translator.trans('scoreflection-translate.forum.badge.machine', {
              lang: (assist.lang || '').toUpperCase(),
            })}
          </span>
        </div>
        <div className="SfTranslate-assist-body">{assist.content}</div>
      </div>
    );
  }

  translateButton(post) {
    // Only offered when we could actually act on it: a post with no declared
    // source language is untranslatable by design, and a reader with no assist
    // language has not told us what to translate INTO.
    const target = app.session.user && app.session.user.attribute('assistLang');
    if (!target || !post.attribute('sourceLang')) return null;
    if (target === post.attribute('sourceLang')) return null;

    return Button.component(
      {
        className: 'Button Button--link SfTranslate-request',
        loading: this.loading,
        onclick: () => this.request(post, target),
      },
      app.translator.trans('scoreflection-translate.forum.translate_this', {
        lang: target.toUpperCase(),
      })
    );
  }

  request(post, lang) {
    this.loading = true;
    this.error = null;

    return app
      .request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/posts/${post.id()}/translate`,
        body: { data: { lang } },
      })
      .then((result) => {
        const a = result.data.attributes;
        this.requested = {
          lang: a.targetLang,
          content: a.content,
          approved: a.approved,
          machine: a.origin === 'machine',
        };
      })
      .catch(() => {
        // 503 is the ordinary "no engine configured / provider down" answer,
        // not a fault worth an error dialog.
        this.error = app.translator.trans('scoreflection-translate.forum.unavailable');
      })
      .then(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
